import { createFileRoute } from '@tanstack/react-router'
import ErrorFallback from '@/components/ErrorFallback'
import { BosunProvisioningPage } from '../bosun'

export const Route = createFileRoute('/_authenticated/projects/$workspaceUuid/new')({
  component: NewWorkspaceProjectPage,
  errorComponent: ErrorFallback,
})

function NewWorkspaceProjectPage() {
  const { workspaceUuid } = Route.useParams()
  return <BosunProvisioningPage workspaceUuid={workspaceUuid} />
}
